module.exports = __webpack_public_path__ + "img/fig21.7003b036.jpg";